import { render, staticRenderFns } from "./bookmark-woman.vue?vue&type=template&id=1ffea68c&scoped=true&"
import script from "./bookmark-woman.vue?vue&type=script&lang=js&"
export * from "./bookmark-woman.vue?vue&type=script&lang=js&"
import style0 from "./bookmark-woman.vue?vue&type=style&index=0&id=1ffea68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffea68c",
  null
  
)

export default component.exports